define('editor/edit/layers/edit/layerBase',['knockout', 'knockout-mapping', 'plugins/http', 'durandal/app'], function (ko, komapping, http, app) {
    var viewmodel = function () {
        var self = this;

        self.layer = null;
        self.backup = null;
        self.name = ko.observable();
        self.isDirty = true; // assume edit

        self.activate = function (editorMapId, layer, backToListFunc) {
            self.editorMapId = editorMapId;
            self.layer = layer;
            self.backup = ko.toJS(self.layer);
            self.exit = backToListFunc;
            self.name(self.layer.name());

            app.trigger('layer:editing', self.layer);
            
            app.on('layers:drawing', function () {
                self.cancelCommand();
            });
        };

        self.detached = function () {
            if (self.isDirty) {
                self.cancelCommand();
            }
        };

        self.cancelCommand = function () {
            // delete if newly created and then cancelled
            if (self.backup.state.properties && self.backup.state.properties.cancelToDelete) {
                app.trigger("layer:delete", self.layer);
            } else {
                // revert to initial layer state
                var mapped = komapping.fromJS(self.backup.state);

                delete mapped['__ko_mapping__'];

                self.layer.name(self.backup.name);
                self.layer.state(mapped);
                app.trigger("layer:saved", self.layer);
            }
            self.isDirty = false;
            app.off('layers:drawing');
            self.exit();
        };

        self.saveCommand = function () {
            self.layer.name(self.name());
            if (self.layer.state().properties && self.layer.state().properties.cancelToDelete) {
                self.layer.state().properties.cancelToDelete = null;
            }

            self.save()
                .done(function (response) {
                    if (response.success) {
                        app.trigger('layer:saved', self.layer);
                        self.isDirty = false;
                        app.off('layers:drawing');
                        self.exit();
                    } else {
                        self.saveError();
                    }
                }).fail(self.saveError);
        };

        self.save = function () {
            var url = '/api/editor/layers',
                data = {
                    editorMapId: self.editorMapId,
                    layerId: self.layer.id(),
                    order: self.layer.order(),
                    name: self.layer.name(),
                    visible: self.layer.visible(),
                    state: self.layer.state()
                };

            return http.post(url, data);
        };
    };

    return viewmodel;
});

